// Sentry Configuration for Squeaky Town
// To enable: Get DSN from https://sentry.io

import * as Sentry from "@sentry/react";

export const initSentry = () => {
    // Only initialize if DSN is provided
    const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

    if (!SENTRY_DSN || SENTRY_DSN === 'PLACEHOLDER') {
        console.warn('Sentry DSN not configured. Error tracking disabled.');
        return;
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
            }),
        ],

        // Performance Monitoring
        tracesSampleRate: 1.0, // Capture 100% of transactions (reduce in production)

        // Session Replay
        replaysSessionSampleRate: 0.1, // 10% of sessions
        replaysOnErrorSampleRate: 1.0, // 100% of sessions with errors

        // Environment
        environment: import.meta.env.MODE,

        // Release tracking (optional)
        // release: "squeaky-town@" + import.meta.env.VITE_APP_VERSION,
    });
};
